<lib-collab-sidebar
  class="sidebar-shadow"
  [collabList]="collabs()"
  [currentUserIds]="currentUserIds()"
  [selectedCollab]="selectedCollab()"
  [showSiteFilter]="showSiteFilter()"
  [patientDataState]="selectedPatient().state"
  [sites]="siteOptions()"
  [filtersOpen]="filtersOpen()"
  [searchTerm]="searchTerm()"
  [hasDeletedCollabs]="hasDeletedCollabs()"
  [isDisabled]="speechRecognitionStatus() === 'recording'"
  [isPatientContext]="!!patientId()"
  (createNewCollab)="openCreateCollabDialog($event)"
  (selectCollab)="onSelectCollab($event)"
  (toggleFilters)="onToggleFilters()"
  (clearFilters)="onClearFilters()"
  (collabListEndReached)="loadOlderCollabs()"
/>
<div
  class="collab-area-wrapper relative ml-[-1rem] flex max-h-full flex-grow flex-col overflow-hidden px-4 pt-4"
  [class.empty]="!selectedCollab().data && selectedCollab().state === DataState.Fetched"
  [class.pb-4]="!selectedCollab().data?.daysLeftOfDeletion"
>
  @if (selectedCollab().state !== DataState.Fetched) {
    <div class="loading-chat-header-skeleton flex animate-pulse items-center justify-between">
      <div class="skeleton-loader h-[16px] w-[50%] rounded-full bg-background-light-grey"></div>
      <div class="flex items-center gap-2">
        <div class="skeleton-loader h-[24px] w-[24px] rounded-full bg-background-light-grey"></div>
        <div class="skeleton-loader h-[24px] w-[24px] rounded-full bg-background-light-grey"></div>
      </div>
    </div>
    <div class="loading-chat-footer-skeleton absolute bottom-4 flex w-[calc(100%_-_2rem)] animate-pulse gap-3">
      <div class="skeleton-loader h-[24px] w-[24px] rounded-lg bg-background-light-grey"></div>
      <div class="skeleton-loader h-[24px] flex-grow rounded-full bg-background-light-grey"></div>
      <div class="skeleton-loader h-[24px] w-[24px] rounded-full bg-background-light-grey"></div>
    </div>
  } @else {
    @if (selectedCollab().data) {
      @if (isSupportCollab()) {
        <lib-support-collab-chat-header [expanded]="supportCollabHeaderExpanded()" />
      }
      @if (!isSupportCollab() && chatHeaderInfo(); as chatHeaderInfo) {
        <button (click)="onOpenAddParticipantsModal()" class="ml-[-1rem] border-b-[1px] border-background-light-blue pb-4 pl-4">
          <lib-collaboration-chat-header
            [chatHeaderInfo]="chatHeaderInfo"
            [participantsString]="undefined | collaborationDynamicTitle: chatHeaderInfo.allParticipants : currentUserIds()"
          />
        </button>
      }
      <div #scrollContainer class="flex-grow rotate-180 overflow-auto pb-10 pt-12 direction-rtl" (wheel)="onMouseWheel($event)">
        <div
          libInfiniteScrollList
          (startReached)="loadOlderMessage()"
          class="flex min-h-full rotate-180 flex-col justify-end direction-ltr"
        >
          @for (message of messagesWithoutSystemMessages(); track message.id; let first = $first; let last = $last) {
            @if (newMessageMarkerBeforeMessageId() === message.id) {
              <lib-new-message-marker class="py-8"></lib-new-message-marker>
            }

            @if ($index === 0 || (message.sentAt | datesHaveBiggerGap: messages()![$index - 1].sentAt)) {
              <div class="typo-h5-book mx-auto mt-3 flex gap-2 pt-2 text-text-light">
                <span>{{ message.sentAt | date: 'mediumDate' }}</span>
                <span>{{ message.sentAt | date: 'shortTime' }}</span>
              </div>
            }
            <lib-message
              class="mt-3"
              libInfiniteScrollListItem
              [message]="message"
              [showcaseMode]="isShowcase()"
              [searchTextToHighlight]="searchTerm()"
              [isSupportCollab]="isSupportCollab()"
              [participantCount]="participantCount()"
              [isCollabSoftDeleted]="!!selectedCollab().data?.daysLeftOfDeletion"
              (unsendMessage)="onUnsendMessage(selectedCollab().data?.id, message.id)"
              (markMessageUnread)="onMarkMessageUnread(selectedCollab().data?.id, message.id)"
              (downloadTap)="onDownloadTap(message.id)"
              (downloadAttachments)="onDownloadAttachments()"
              (selection)="onSelection($event)"
              (deselection)="onDeselection($event)"
              (retrySendMessage)="onRetrySendMessage($event)"
            ></lib-message>
          }
        </div>
      </div>
      @if (selectedCollab().data?.daysLeftOfDeletion) {
        <div class="ml-[-16px] flex w-[calc(100%+32px)] flex-col items-center bg-background-light-grey py-8">
          <span class="typo-h5-semibold text-text-black">{{ 'collab_soft_deleted_title' | translate }}</span>
          <span class="typo-h5-book text-text-primary">{{ 'collab_soft_deleted_info' | translate }}</span>
        </div>
      } @else {
        <lib-message-input
          [hideUploadFromGallery]="!selectedCollab().data?.linkedPatient || !hasImagingSoftware().data || disableImageUpload()"
          [selectedCollaboration]="selectedCollab().data!"
          (send)="onSend($event)"
          (recordClick)="onRecordClick()"
          (toggleDictation)="onToggleDictation()"
          (selectDevice)="onSelectDevice($event)"
          (messageTyping)="onMessageTyping($event)"
        />
      }
    } @else {
      <div class="flex flex-1 flex-col items-center justify-center gap-2">
        <div class="flex w-[465px] max-w-full flex-col items-center text-center text-text-secondary">
          <h4 class="typo-h4-semibold mb-2">{{ 'collab_empty_state_title' | translate }}</h4>
          <h5 class="typo-h5-light">{{ 'collab_empty_state_description' | translate }}</h5>
          <button
            class="mt-6 flex h-[110px] w-[110px] items-center justify-center rounded-[36px] border-2 border-primary-blue bg-background-light-blue text-primary-blue"
            (click)="openCreateCollabDialog(false)"
            [disabled]="selectedPatient().state === DataState.Loading"
          >
            <svg-icon key="px-24-plus"></svg-icon>
          </button>
          <h5 class="typo-h5-light mb-4 mt-20">{{ 'collab_empty_state_preview_description' | translate }}</h5>
          <img class="w-[183px] rounded-[12px] shadow-[2px_2px_60px_0_#0000001a]" src="assets/images/empty-collab-item.jpg" width="183" />
        </div>
      </div>
    }
  }
</div>
